import React, { CSSProperties, useMemo, useState } from "react"
import { colors, css, fonts } from "../../../Styles";
import { useTranslation } from "react-i18next";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";

interface EsfStationBasic_Props{
  station?: EsfLocation;
  borderRadius?: CSSProperties;
}

export function EsfStationBasic({ station, borderRadius }: EsfStationBasic_Props) {
  const { t } = useTranslation()
  
  return (
    <div
      style={{
        height: "30px",
        width: "170px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          alignContent: "center",
          boxSizing: "border-box",
          padding: "0px 10px",
          backgroundColor: colors.greyLightSecondary,
          color: colors.greyDarkPrimary,
          ...fonts.paragraph,
          ...fonts.fontSize4,
          ...borderRadius,
        }}
      >
        {`Station ${station?.name}`}
      </div>
    </div>
  );
}

interface EsfSectionBasic_Props {
  stations: EsfLocation[]
  sectionId: number;
}

export function EsfSectionBasic({ stations, sectionId }: EsfSectionBasic_Props) {
  const {t} = useTranslation()

  // Error throwback if there are no pens
  if (stations.length === 0) {
    return <p style={{...css.paragraph, ...css.fontSize4, color: colors.greyDarkPrimary}}>{t("noData", {defaultValue:"no data"})}</p>;
  }

  const numRows = Math.ceil(stations.length / 1);

  const section = stations.map((station, index) => {
    const rowIndex = Math.floor(index / 1);

    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === numRows - 1;

    let borderRadius = "0px";

    if (isFirstRow) borderRadius = "10px 10px 0px 0px";
    if (isLastRow) borderRadius = "0px 0px 10px 10px";

    return ( 
      <EsfStationBasic
        key={station.location_id}
        station={station}
        borderRadius={{ borderRadius }}
      />
    )   
  })
  
  return (
    <div style={{ width: "fit-content", height: "fit-content", gap: "10px", borderRadius: "10px" }}>
       <div style={{ display: "grid", gridTemplateColumns: "1fr", width: "fit-content", gap: "10px", borderRadius: "10px" }}>
          {section}
        </div>
    </div>
  )
}